import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  showMessage(type: 'success' | 'error' | 'warning' | 'info',message?: string, title='Close', duration = 3000) {
    this.snackBar.open(message as string, title, {
      duration,
      panelClass: [`snackbar-${type}`], // Dynamically assign class
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
  }
}
